import { render, staticRenderFns } from "./RebateRecord.vue?vue&type=template&id=ca45ef76&scoped=true"
import script from "./RebateRecord.vue?vue&type=script&lang=js"
export * from "./RebateRecord.vue?vue&type=script&lang=js"
import style0 from "./RebateRecord.vue?vue&type=style&index=0&id=ca45ef76&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca45ef76",
  null
  
)

export default component.exports